import { Component, OnInit } from '@angular/core';

import { FooterList } from '@infocert/ng-ui-kit/models';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

enum FooterEnum {
  PRIVACY_POLICY,
  COOKIE_POLICY,
  PRIVACY_NOTICE,
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  footerPostList$: Observable<FooterList[]>;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.footerPostList$ = this.translateService
      .stream([
        'FOOTER.SUBTITLES.PRIVACY_POLICY',
        'FOOTER.SUBTITLES.COOKIE_POLICY',
        'FOOTER.SUBTITLES.PRIVACY_NOTICE',
        'COMMON.OPENS_NEW_TAB',
      ])
      .pipe(
        map(res => [
          {
            label: res['FOOTER.SUBTITLES.PRIVACY_POLICY'],
            ariaLabel: `${res['FOOTER.SUBTITLES.PRIVACY_POLICY']} ${res['COMMON.OPENS_NEW_TAB']}`,
            role: 'link',
            onClick: () => this._openLink(FooterEnum.PRIVACY_POLICY),
          } as FooterList,
          {
            label: res['FOOTER.SUBTITLES.COOKIE_POLICY'],
            ariaLabel: `${res['FOOTER.SUBTITLES.COOKIE_POLICY']} ${res['COMMON.OPENS_NEW_TAB']}`,
            role: 'link',
            onClick: () => this._openLink(FooterEnum.COOKIE_POLICY),
          } as FooterList,
          {
            label: res['FOOTER.SUBTITLES.PRIVACY_NOTICE'],
            ariaLabel: `${res['FOOTER.SUBTITLES.PRIVACY_NOTICE']} ${res['COMMON.OPENS_NEW_TAB']}`,
            role: 'link',
            onClick: () => this._openLink(FooterEnum.PRIVACY_NOTICE),
          } as FooterList,
        ])
      );
  }

  private _openLink(value: FooterEnum): void {
    const key =
      value === FooterEnum.PRIVACY_POLICY
        ? 'PRIVACY_POLICY'
        : value === FooterEnum.COOKIE_POLICY
        ? 'COOKIE_POLICY'
        : 'PRIVACY_NOTICE';

    const url = this.translateService.instant(`URLS.${key}`);
    window.open(url, '_blank');
  }
}
